import callWebGate from './callWebGate';

export function fetchAudienceSize(targeting, wgToken, webGate = callWebGate) {
  const url = 'audience-proxy/v1/query';
  return webGate(url, wgToken, { method: 'POST', body: targeting })
    .then(r => {
      return r.ok ? r.json() : r.json().then(errorMessage => Promise.reject(errorMessage));
    });
}

export function fetchAudienceSizeV2(targeting, wgToken, webGate = callWebGate) {
  const url = 'audience-proxy/v2/query';
  return webGate(url, wgToken, { method: 'POST', body: targeting })
    .then(r => {
      return r.ok ? r.json() : r.json().then(errorMessage => Promise.reject(errorMessage));
    });
}



// WEBPACK FOOTER //
// ./src/api/audienceSizer.js